import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { FormThirdPartyConsignmentComponent } from '../../cargo/manual-creation-cargo/components/form-third-party-consignment/form-third-party-consignment.component';
import { Permission } from 'src/app/core/resources/permission';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { ThirdPartyConsignmentService } from '../../cargo/manual-creation-cargo/components/third-party-consignment/third-party-consignment.service';
import { ThirdParty } from 'src/app/core/interfaces/thirdParty';
import { Utils } from 'src/app/core/resources/utils';

@Component({
  selector: 'app-list-third-party',
  templateUrl: './list-third-party.component.html',
  styleUrls: ['./list-third-party.component.scss']
})
export class ListThirdPartyComponent implements OnInit {
  permission = Permission;
  thirdPartyFilter: string = '';
  listThirdParties: ThirdParty[] = [];
  constructor(
    private thirdPartyConsignmentService: ThirdPartyConsignmentService,
    public utils: Utils,
    public dialog: MatDialog,
    public permissionRole: PermissionRole,
  ) { }

  ngOnInit() {
    this.getThirdParties();
  }

  private getThirdParties() {
    this.thirdPartyConsignmentService.getThirdPartiesByParent().subscribe(
      (success: ThirdParty[]) => {
        this.listThirdParties = success && success.length > 0 ? success.sort((a, b) => {
          if (!a.name) return 1;
          if (!b.name) return -1;
          return a.name.localeCompare(b.name);
        }) : [];
      },
      () => this.listThirdParties = []
    );
  }

  createThirdParty() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      newThirdParty: true,
      title: "Tercero",
      options: {
        currentThirdPartyList: this.listThirdParties
      }
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(FormThirdPartyConsignmentComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => result && result.state && this.getThirdParties());
  }
}
